import CashPendingSaleCard from '../cards/CashPendingSaleCard';

import CashPendingSaleListItem from '../cards/CashPendingSaleListItem';

import { PendingSalesViewMode } from '../../../../types/cash/pendingCashSale.types';

import { PendingCashierSaleCardDTO } from '../../../../types/sale/dto/PendingCashierSaleCardDTO';

interface Props {
  sales: PendingCashierSaleCardDTO[];

  viewMode: PendingSalesViewMode;

  onViewSale: (saleId: number) => void;

  onProcessSale: (sale: PendingCashierSaleCardDTO) => void;

  /** Solo ADMIN / SOPORTE. Muestra el botón para anular la venta pendiente. */
  canCancel?: boolean;

  onCancelSale?: (sale: PendingCashierSaleCardDTO) => void;
}

const CashPendingSalesList = ({
  sales,
  viewMode,
  onViewSale,
  onProcessSale,
  canCancel = false,
  onCancelSale,
}: Props) => {
  // =====================================================
  // 🔹 Empty State
  // =====================================================

  if (!sales.length) {
    return (
      <div
        className="
          flex
          items-center
          justify-center

          rounded-2xl

          border
          border-dashed
          border-slate-300

          bg-white

          p-10

          text-center

          dark:border-strokedark
          dark:bg-boxdark
        "
      >
        <div>
          <h3
            className="
              mb-1
              text-lg
              font-semibold
              text-slate-700

              dark:text-white
            "
          >
            No hay ventas pendientes
          </h3>

          <p
            className="
              text-sm
              text-slate-500

              dark:text-slate-400
            "
          >
            Las ventas enviadas a caja aparecerán aquí.
          </p>
        </div>
      </div>
    );
  }

  // =====================================================
  // 🔹 Grid View
  // =====================================================

  if (viewMode === 'grid') {
    return (
      <div
        className="
          grid
          grid-cols-1
          gap-4

          sm:grid-cols-2
          lg:grid-cols-3
          2xl:grid-cols-4
          3xl:grid-cols-5
        "
      >
        {sales.map((sale) => (
          <CashPendingSaleCard
            key={sale.saleId}
            sale={sale}
            onViewSale={onViewSale}
            onProcessSale={onProcessSale}
            canCancel={canCancel}
            onCancelSale={onCancelSale}
          />
        ))}
      </div>
    );
  }

  // =====================================================
  // 🔹 List View
  // =====================================================

  return (
    <div className="space-y-3">
      {sales.map((sale) => (
        <CashPendingSaleListItem
          key={sale.saleId}
          sale={sale}
          onViewSale={onViewSale}
          onProcessSale={onProcessSale}
          canCancel={canCancel}
          onCancelSale={onCancelSale}
        />
      ))}
    </div>
  );
};

export default CashPendingSalesList;
